<template>
  <div>
    <back-route-hdr :back-mode="'static'"></back-route-hdr>

    <van-cell-group class="mar-top">
      <van-cell center title="忽略会议通知">
        <template #right-icon>
          <van-switch v-model="ignoreNotice" size="20"></van-switch>
        </template>
      </van-cell>
    </van-cell-group>

    <van-cell-group class="mar-top text-center" v-show="showPermits.logout">
      <van-cell clickable @click="logout" class="text-danger">
        <template #title>
          <i class="iconfont icon-tuichu mar-rgt-5"></i><span>退出登录</span>
        </template>
      </van-cell>
    </van-cell-group>
  </div>
</template>

<script>
  import {account} from "../../../../server";
  import {getStorage, StorageKey, clearStorage} from "../../../../tools/storage";
  import {checkShowPermit, frontConfirm} from "../../../../tools/utils";

  export default {
    data() {
      return {
        userId: getStorage(StorageKey.userId),
        ignoreNotice: false,
        userInfo: null
      }
    },
    computed: {
      // 权限
      showPermits() {
        const permissionList = this.$store.state.permissionList || [];
        return {
          logout: checkShowPermit(permissionList, this.permitsMap.logout),
        }
      },
    },
    watch: {
      ignoreNotice(val) {
        // console.log("ignoreNotice", val);
        this.setIgnoreNotice(val)
      }
    },
    created() {
      this.getSelfUserInfo()
    },
    methods: {
      getSelfUserInfo() {
        account.queryList(this, {queryFilter: {selfCursor: this.userId}}).then(({searchUserList: data = {}}) => {
          const [{user} = {}] = data.userEdges || [];
          // console.log(user);
          this.userInfo = user;
          this.ignoreNotice = user && user.ignoreNotice
        })
      },
      setIgnoreNotice(ignore) {
        if (this.userInfo && this.userInfo.ignoreNotice === ignore) return;
        account.setIgnoreNotice(this, {ignore}).then(({setIgnoreNotice: resp = {}}) => {
          this.getSelfUserInfo()
        }).catch(err => {
          messageHdl.call(this, {msg: err.message});
        })
      },
      // 退出登录
      logout() {
        frontConfirm({
          title: "退出登录",
          msg: "是否确认退出当前账号？",
          withCancel: true
        }, (res) => {
          res && account.logout(this).then(({logout: resp = {}}) => {
            if (resp.code === 0) {
              clearStorage();
              window.location = '/login'
            } else {
              messageHdl.call(this, {msg: resp.errMsg || '登出失败'});
            }
          }).catch(err => {
            messageHdl.call(this, {msg: err.message});
          })
        })
      },
    }
  }
</script>

<style scoped>
</style>
